import React from 'react'

const HeaderPlaceholder = () => {
  // TODO fill it with skeletons
  return <div style={{ height: '64px' }}></div>
}

export default HeaderPlaceholder
